import styled, { StyledComponentPropsWithRef } from 'styled-components'

import { theme } from 'styles/theme'

// A plain circle. When selected: a dark ring, a white gap and a yellow center.
const RadioCircle = styled.span`
  flex: none;
  box-sizing: border-box;
  inline-size: 18px;
  block-size: 18px;
  border: 1px solid ${theme.colors.DarkGrey};
  border-radius: 50%;
  background-color: ${theme.colors.White};
`

// The native radio input is kept (hidden) for the selection and keyboard behavior, and the circle is drawn instead
const HiddenRadioInput = styled.input.attrs({ type: 'radio' })`
  position: absolute;
  opacity: 0;
  pointer-events: none;
  :checked + ${RadioCircle} {
    border: 1px solid ${theme.colors.MainBlack};
    background-color: ${theme.colors.MainYellow};
    box-shadow: inset 0 0 0 2px ${theme.colors.White};
  }
  :focus-visible + ${RadioCircle} {
    outline: 1px solid ${theme.colors.MainYellow};
    outline-offset: 2px;
  }
`

type RoundRadioButtonProps = Omit<StyledComponentPropsWithRef<typeof HiddenRadioInput>, 'type'>

// A single round radio button, without a label. Put it inside a <label> with its text, so clicking the text selects it.
export const RoundRadioButton = (props: RoundRadioButtonProps) => (
  <>
    <HiddenRadioInput {...props} />
    <RadioCircle />
  </>
)
